import React from 'react';
import Logo from './Logo';
const Footer = () => {
  return <footer className="py-6 bg-gray-50 border-t border-gray-100" data-id="element-694" data-mp="1h3mbmvptajp2">
      <div className="container px-4 mx-auto" data-id="element-695" data-mp="2n3r1ig63uogv">
        <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0" data-id="element-696" data-mp="2i3ctgy4i7eiu">
          <div className="flex items-center" data-id="element-697" data-mp="2d4id02u0e21w">
            <a href="https://www.conversion.com.br/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:opacity-80 transition-opacity" data-id="element-698" data-mp="2d3qhst4bq6c5">
              <Logo isFooter={true} data-id="element-699" data-mp="24a3n76bur94j" />
            </a>
          </div>
          <div className="text-sm text-gray-500" data-id="element-700" data-mp="1zdd8onfp4ll8">
            © {new Date().getFullYear()} Conversion. Todos os direitos
            reservados.
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;